const SPECTRUM_NS = 'http://www.profium.com/spectrum/';
const ARCHIVE_NS = 'http://www.profium.com/archive/';
const IMAGEARCHIVE_NS = 'http://www.profium.com/imagearchive/2007/';
const PROFIUM_NS = 'http://www.profium.com/schema/v5/';
const CE_NS = 'http://www.profium.com/spectrum/ce/';

const Predicates = {
  ARCHIVE: {
    NS: ARCHIVE_NS,
    DEPICTED_OBJECT_INVERSE: ARCHIVE_NS + 'depictedObjectInverse',
    PRIMARY_VERSION: ARCHIVE_NS + 'primaryVersion',
    FINNA_PUBLISHING: ARCHIVE_NS + 'finnaPublishing'
  },
  SPECTRUM: {
    NS: SPECTRUM_NS,
    ACTOR_FORMAT: SPECTRUM_NS + 'Actor',
    LOCATION_INFORMATION_FORMAT: SPECTRUM_NS + 'LocationInformation',
    ACTOR_INVERSE: SPECTRUM_NS + 'actorInverse',
    RELATED_OBJECT: SPECTRUM_NS + 'relatedObject',
    RELATED_OBJECT_TARGET: SPECTRUM_NS + 'relatedObjectTarget',
    FILE: SPECTRUM_NS + 'file',
    PRIMARY_NUMBER: SPECTRUM_NS + 'primaryNumber',
    PRIMARY_NUMBER_SPECIFIER: SPECTRUM_NS + 'primaryNumberSpecifier',
    SUB_NUMBER: SPECTRUM_NS + 'subNumber',
    SUB_NUMBER_SPECIFIER: SPECTRUM_NS + 'subNumberSpecifier',
    ACTOR: SPECTRUM_NS + 'actor',
    IS_PARENT_COLLECTION: SPECTRUM_NS + 'isParentCollection',
    IS_SPECIAL_COLLECTION: SPECTRUM_NS + 'isSpecialCollection',
    IS_INDEPENDENT_COLLECTION: SPECTRUM_NS + 'isIndependentCollection',
    PARENT_COLLECTION: SPECTRUM_NS + 'parentCollection',
    MATERIAL_ID: SPECTRUM_NS + 'materialIdentifier',
    ACQUISITION_COLLECTION: SPECTRUM_NS + 'acquisitionCollection',
    ACQUISITION_SPECIAL_COLLECTION: SPECTRUM_NS + 'acquisitionSpecialCollection',
    OBJECT_ACQUISITION_INFORMATION: SPECTRUM_NS + 'objectAcquisitionInformation',
    ROLE: SPECTRUM_NS + 'role',
    ACQUISITION_OBJECT: SPECTRUM_NS + 'acquisitionObject',
    CLASSIFICATION: SPECTRUM_NS + 'classification',
    GENERAL_ACTOR_ROLE_INVERSE: SPECTRUM_NS + 'generalActorRoleInverse',
    MAP_GEOMETRY: SPECTRUM_NS + 'mapGeometry',
    REFERENCE_NUMBER: SPECTRUM_NS + 'referenceNumber',
    FORENAMES: SPECTRUM_NS + 'forenames',
    SURNAME: SPECTRUM_NS + 'surnameOrName',
    LOCATION_REFERENCE: SPECTRUM_NS + 'locationReferenceNameOrNumber',
    CE: {
      NS: CE_NS,
      LINK_TO_BUILT_SITE: CE_NS + 'linkToBuiltSite',
      BUILT_SITE_BUILDINGS: CE_NS + 'builtSiteBuildings',
      SITE_VISIT: CE_NS + 'siteVisit',
      CONTRIBUTION: CE_NS + 'contribution',
      STATEMENT_TEXT: CE_NS + 'statementText',
      SIGNABLE_STATEMENT: CE_NS + 'signableStatement',
      SOLVER: CE_NS + 'solver',
      DEMONSTRATOR: CE_NS + 'demonstrator',
      PROPERTY_ID: CE_NS + 'propertyID',
      BUILDING_ID: CE_NS + 'buildingID',
      PROPERTY_FORMAT: CE_NS + 'Property',
      AREA_FORMAT: CE_NS + 'Area',
      ARCHEOLOGICAL_SITE_FORMAT: CE_NS + 'ArcheologicalSite',
      BUILDING_FORMAT: CE_NS + 'Building',
      PROJECT_FORMAT: CE_NS + 'Project',
      INSPECTION_FORMAT: CE_NS + 'Inspection',
      LOCAL_MUSEUM_FORMAT: CE_NS + 'LocalMuseum',
      STATEMENT_FORMAT: CE_NS + 'Statement',
      PROPERTY_ID: CE_NS + 'propertyID',
      BUILDING_ID: CE_NS + 'buildingID'
    }
  },

  IMAGEARCHIVE: {
    NS: IMAGEARCHIVE_NS,
    CATEGORY: IMAGEARCHIVE_NS + 'category',
    PLACE_COORDINATES: SPECTRUM_NS + 'placeCoordinates',
    P_CENTER: SPECTRUM_NS + 'pCoordinateCenterPoint',
    I_CENTER: SPECTRUM_NS + 'iCoordinateCenterPoint',
    P_NORTH: SPECTRUM_NS + 'pCoordinateNorthPoint',
    P_SOUTH: SPECTRUM_NS + 'pCoordinateSouthPoint',
    I_EAST: SPECTRUM_NS + 'iCoordinateEastPoint',
    I_WEST: SPECTRUM_NS + 'iCoordinateWestPoint'
  },
  PROFIUM: {
    LOCATION: PROFIUM_NS + 'location',
    POINT: PROFIUM_NS + 'point',
    POLYGON: PROFIUM_NS + 'polygon',
    LINE_STRING: PROFIUM_NS + 'lineString'
  }
};

export default Predicates;

export const ARCHIVE = Predicates.ARCHIVE;
export const SPECTRUM = Predicates.SPECTRUM;